import { joinBy } from '@pbk/utils';
import { checkIsClientRelatedError } from '../checkIsClientRelatedError';
import { CORRELATION_ID_HEADER } from '../constants';
import { logError } from './logError';
export const logUnhandledMutationError = (error) => {
    const isClientRelatedError = checkIsClientRelatedError(error);
    if (!isClientRelatedError)
        return undefined;
    const correlationId = error.config?.headers[CORRELATION_ID_HEADER];
    const url = error.config?.url;
    const message = joinBy(['Unhandled mutation error', url], ' ');
    logError(message, {
        extra: { error },
        tags: { unhandledMutationError: true, correlationId, url },
    });
};
